module.exports = __webpack_public_path__ + "img/pjt02.30a84c73.png";